module.exports = __webpack_public_path__ + "img/djzx.ec937d2a.jpg";